import {
    InviteWorkspaceAssignment,
    InviteWorkspaceAssignmentBase,
} from "@common/types/inviteCode";
import { WorkspaceDto } from "../workspace/workspace.dto";

export class OrganizationInviteWorkspaceAssignmentDto {
    static deserialize(
        dto: OrganizationInviteWorkspaceAssignmentDto,
    ): InviteWorkspaceAssignment {
        return {
            workspace: WorkspaceDto.deserialize(
                dto.workspace,
            ) as InviteWorkspaceAssignment["workspace"],
        };
    }

    workspace: WorkspaceDto;

    constructor(workspaceAssignment: InviteWorkspaceAssignmentBase) {
        this.workspace = new WorkspaceDto(workspaceAssignment.workspace);
    }
}
